// composables/useCart.ts
import { reactive, onMounted } from 'vue'
import type { CartItem } from '@/types/CartItem'
import type { ICartService } from '@/services/cartService'
import { Cart } from '@/types/Cart'

export function useCart(service: ICartService)
{
  //const cart = reactive<{ items: CartItem[] }>({ items: [] })
  const cart = reactive(new Cart())

  onMounted(loadCart)
  
  async function loadCart()
  {
    const items = await service.getCart()
    //cart.items.splice(0, cart.items.length, ...data.items);
    //console.log('loadCart', items);
    cart.replaceItems(items);
  }

  const addItem = async (item: CartItem) =>
  {
    const items = await service.addItem(item)
    /*cart.items.length = 0;
    cart.items.push(...data.items);*/
    cart.replaceItems(items);
  }

  const addProdItem = async (productId: string, qty: number) =>
  {
    const items = await service.addProdItem(productId, qty)
    /*cart.items.length = 0;
    cart.items.push(...data.items);*/
    cart.replaceItems(items);
  }

  const removeItem = async (productId: string) =>
  {
    const items = await service.removeItem(productId)
    cart.items.length = 0;
    cart.replaceItems(items);
    //cart.items.splice(0, cart.items.length, ...data.items);
  }

  const clearCart = async () =>
  {
    await service.clearCart();
    //cart.items = [];
    //cart.items.length = 0;
    cart.replaceItems([]);
  }

  /*
  function replaceItems(newItems: CartItem[])
  {
    cart.items.length = 0;
    cart.items.push(...newItems);
  }*/

  const changeItemQuantity = async (cartItem: CartItem, chgQtyBy: number) =>
  {
    const items = await service.changeItemQuantity(cartItem, chgQtyBy)
    cart.replaceItems(items);
  }

  const hasDiscounts = () =>
  {
    return cart.haveDiscounts();
  }

  return { cart, addItem, removeItem, clearCart, addProdItem, changeItemQuantity, hasDiscounts }
}
